// Mock data for Palerm Insurance Agency

export const companyInfo = {
  name: "Palerm Insurance Agency",
  legalName: "Palerm Insurance Agency LLC",
  npn: "18665200", // Agency NPN - Verified from LICENSE.xlsx
  phone: "469-434-8287",
  phoneWhatsApp: "+14694348287",
  fax: "800-887-4484", // Confirmed by Gabriel
  tollFree: "1-855-PALERM-1",
  address: "400 Stonebrook Pkwy Unit 503, Frisco, TX 75036",
  email: "info@palerminsurance.com",
  yearsOfService: "25+",
  tagline: {
    en: "Your Insurance Agent With a Personal Touch",
    es: "Su Agente de Seguros con un Toque Personal"
  },
  subtitle: {
    en: "— Backed by Experience, Built on Trust.",
    es: "— Respaldado por Experiencia, Construido sobre Confianza."
  },
  socialMedia: {
    facebook: "https://www.facebook.com/palerminsurance",
    instagram: "https://www.instagram.com/palerminsurance/",
    youtube: "https://www.youtube.com/@palerminforma8674",
    x: "https://x.com/palerminsurance"
  },
  quoteLinks: {
    sola: "https://solainsurance.com/get-quote/palermg@segurospalerm.com",
    clickInsurance: "https://www.myclickinsurance.com/palerminsurance",
    agencyStream: "https://api.agencystream.com/widget/auto-quote-widget.js",
    autoPersonal: "/products/auto"
  },
  whatsappMessage: {
    en: "Favor enviar la siguiente información: Nombre, Direccion, Fecha Nacimiento, Correo electrónico y teléfono",
    es: "Favor enviar la siguiente información: Nombre, Direccion, Fecha Nacimiento, Correo electrónico y teléfono"
  }
};

export const navigation = {
  en: [
    { label: "Home", path: "/" },
    { label: "Life Insurance", path: "/products/life" },
    { label: "Travel Insurance", path: "/products/travel" },
    { label: "Products", path: "/products", submenu: [
      { label: "Auto Insurance", path: "/products/auto" },
      { label: "Home Insurance", path: "/products/home" },
      { label: "Business Insurance", path: "/products/business" },
      { label: "Bonds", path: "/products/bonds" }
    ]},
    { label: "Our Agents", path: "/agents" },
    { label: "Customer Service", path: "/customer-service" },
    { label: "FAQ", path: "/faq" },
    { label: "Resources", path: "/resources" },
    { label: "Contact", path: "/contact" }
  ],
  es: [
    { label: "Inicio", path: "/" },
    { label: "Seguros de Vida", path: "/products/life" },
    { label: "Seguro de Viaje", path: "/products/travel" },
    { label: "Productos", path: "/products", submenu: [
      { label: "Seguro de Auto", path: "/products/auto" },
      { label: "Seguro de Hogar", path: "/products/home" },
      { label: "Seguro de Negocio", path: "/products/business" },
      { label: "Fianzas", path: "/products/bonds" }
    ]},
    { label: "Nuestros Agentes", path: "/agents" },
    { label: "Servicio al Cliente", path: "/customer-service" },
    { label: "Preguntas Frecuentes", path: "/faq" },
    { label: "Recursos", path: "/resources" },
    { label: "Contacto", path: "/contact" }
  ]
};

export const insuranceProducts = {
  en: [
    {
      id: 1,
      title: "Auto Insurance",
      description: "Protect your vehicle with top-tier coverage.",
      icon: "Car"
    },
    {
      id: 2,
      title: "Home Insurance",
      description: "Safeguard your home and valuables.",
      icon: "Home"
    },
    {
      id: 3,
      title: "Business Insurance",
      description: "Secure your business and livelihood.",
      icon: "Building2"
    },
    {
      id: 4,
      title: "Bonds",
      description: "Professional bonding solutions tailored to your needs.",
      icon: "Shield"
    },
    {
      id: 5,
      title: "Fleet Auto Insurance",
      description: "Coverage for multiple vehicles in your fleet.",
      icon: "Truck"
    },
    {
      id: 6,
      title: "Life Insurance",
      description: "Protect your loved ones and secure their future.",
      icon: "Heart"
    },
    {
      id: 7,
      title: "Travel Insurance",
      description: "Stay protected wherever your journey takes you. Include reference code (RTRL006)",
      icon: "Plane",
      link: "/products/travel"
    },
    {
      id: 8,
      title: "Warranty",
      description: "Extended protection for your valuable investments.",
      icon: "ShieldCheck"
    }
  ],
  es: [
    {
      id: 1,
      title: "Seguro de Auto",
      description: "Proteja su vehículo con cobertura de primer nivel.",
      icon: "Car"
    },
    {
      id: 2,
      title: "Seguro de Casa",
      description: "Proteja su hogar y objetos de valor.",
      icon: "Home"
    },
    {
      id: 3,
      title: "Seguro de Negocio",
      description: "Asegure su negocio y sustento.",
      icon: "Building2"
    },
    {
      id: 4,
      title: "Bonos",
      description: "Soluciones de fianzas profesionales adaptadas a sus necesidades.",
      icon: "Shield"
    },
    {
      id: 5,
      title: "Seguro de Flota",
      description: "Cobertura para múltiples vehículos en su flota.",
      icon: "Truck"
    },
    {
      id: 6,
      title: "Seguro de Vida",
      description: "Proteja a sus seres queridos y asegure su futuro.",
      icon: "Heart"
    },
    {
      id: 7,
      title: "Seguro de Viaje",
      description: "Manténgase protegido dondequiera que lo lleve su viaje. Incluya código de referencia (RTRL006)",
      icon: "Plane",
      link: "/products/travel"
    },
    {
      id: 8,
      title: "Garantía",
      description: "Protección extendida para sus inversiones valiosas.",
      icon: "ShieldCheck"
    }
  ]
};

export const whyChooseUs = {
  en: [
    {
      id: 1,
      title: "25+ Years of Trusted Service",
      description: "Serving the Dallas-Fort Worth community with integrity and expertise."
    },
    {
      id: 2,
      title: "Family-Owned & Hispanic-Owned",
      description: "A locally operated business that understands and values its community."
    },
    {
      id: 3,
      title: "Comprehensive Insurance Solutions",
      description: "Offering auto, home, business, bonds, fleet auto, and life insurance to meet diverse needs."
    },
    {
      id: 4,
      title: "Reputable & Reliable",
      description: "Proud members of local chambers of commerce and business organizations."
    },
    {
      id: 5,
      title: "Experienced & Knowledgeable Agents",
      description: "A dedicated team trained to provide personalized assistance."
    },
    {
      id: 6,
      title: "Commitment to Customer Satisfaction",
      description: "Focused on delivering excellent service and tailored coverage options."
    }
  ],
  es: [
    {
      id: 1,
      title: "Más de 25 Años de Servicio Confiable",
      description: "Sirviendo a la comunidad de Dallas-Fort Worth con integridad y experiencia."
    },
    {
      id: 2,
      title: "Propiedad Familiar e Hispana",
      description: "Un negocio operado localmente que entiende y valora a su comunidad."
    },
    {
      id: 3,
      title: "Soluciones de Seguro Integrales",
      description: "Ofreciendo seguro de auto, hogar, negocio, bonos, flotas y vida para satisfacer diversas necesidades."
    },
    {
      id: 4,
      title: "Reputado y Confiable",
      description: "Miembros orgullosos de cámaras de comercio locales y organizaciones empresariales."
    },
    {
      id: 5,
      title: "Agentes Experimentados y Conocedores",
      description: "Un equipo dedicado capacitado para brindar asistencia personalizada."
    },
    {
      id: 6,
      title: "Compromiso con la Satisfacción del Cliente",
      description: "Enfocados en brindar un excelente servicio y opciones de cobertura personalizadas."
    }
  ]
};

export const happyCustomers = [
  { id: 1, image: "https://images.unsplash.com/photo-1609220136736-443140cffec6" },
  { id: 2, image: "https://images.unsplash.com/photo-1511895426328-dc8714191300" },
  { id: 3, image: "https://images.unsplash.com/photo-1543610892-0b1f7e6d8ac1" },
  { id: 4, image: "https://images.pexels.com/photos/8623333/pexels-photo-8623333.jpeg" },
  { id: 5, image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf" },
  { id: 6, image: "https://images.unsplash.com/photo-1530268729831-4b0b9e170218" }
];

export const insurancePartners = [
  { id: 1, name: "Progressive", logo: "/images/carriers/progressive.svg" },
  { id: 2, name: "Geico", logo: "/images/carriers/geico.svg" },
  { id: 3, name: "NatGeneral", logo: "https://cdn.brandfetch.io/id8OLgVJ-3/w/400/h/132/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 4, name: "Alinsco", logo: "/images/carriers/alinsco.svg" },
  { id: 5, name: "Commonwealth", logo: "https://cdn.brandfetch.io/idpLGGRfEK/w/400/h/147/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 6, name: "Aguila Dorada", logo: "https://cdn.brandfetch.io/idKEh_3D2n/w/400/h/127/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 7, name: "Cover Whale", logo: "https://cdn.brandfetch.io/id6MzKOgpY/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 8, name: "United Auto Insurance", logo: "https://cdn.brandfetch.io/idOT4AyKdO/w/400/h/220/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 9, name: "Loop", logo: "https://cdn.brandfetch.io/idpjBc9OBK/w/400/h/99/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 10, name: "Gainsco", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Gainsco_logo.png/320px-Gainsco_logo.png" },
  { id: 11, name: "Bristol West", logo: "https://cdn.brandfetch.io/id0m9U8lqE/w/400/h/117/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 12, name: "Advantage Auto", logo: "https://cdn.brandfetch.io/idCy-IFlnF/w/400/h/165/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 13, name: "Falcon Insurance", logo: "https://cdn.brandfetch.io/idwgzLKzXd/w/400/h/115/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 14, name: "Apollo MGA", logo: "https://cdn.brandfetch.io/idvCASwfVT/w/400/h/143/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 15, name: "Next", logo: "https://cdn.brandfetch.io/idAnC2sNck/w/400/h/102/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 16, name: "Coterie", logo: "https://cdn.brandfetch.io/idVuKwADYm/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 17, name: "Hagerty", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Hagerty_Logo.svg/320px-Hagerty_Logo.svg.png" },
  { id: 18, name: "Biberk", logo: "https://cdn.brandfetch.io/idKYPBNO7e/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 19, name: "Sola", logo: "https://cdn.brandfetch.io/idE76j2QQl/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 20, name: "Hippo", logo: "https://cdn.brandfetch.io/idP05c4iuz/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 21, name: "Foremost", logo: "https://cdn.brandfetch.io/idI0zEBn7e/w/400/h/141/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 22, name: "Hiscox", logo: "https://cdn.brandfetch.io/idVj-d5x-I/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 23, name: "Jewelers Mutual", logo: "https://cdn.brandfetch.io/idayLLW9Mk/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 24, name: "Simply Business", logo: "https://cdn.brandfetch.io/idPeRa0oj2/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 25, name: "Arkay Auto Warranty", logo: "https://cdn.brandfetch.io/idWh8JKVPT/w/400/h/157/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" }
,
  // First Connect Additional Carriers (avoiding duplicates with existing: Coterie, biBerk, Sola, Hippo, Jewelers Mutual, Simply Business, Arkay, Thimble, Fetch)
  { id: 26, name: "Ahoy", logo: "https://cdn.brandfetch.io/idUmLhqJRl/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 27, name: "Annex Risk", logo: "https://cdn.brandfetch.io/idCBOXHwWl/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 28, name: "Back9", logo: "https://cdn.brandfetch.io/idVPJqpKV8/w/400/h/120/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 29, name: "Bamboo", logo: "https://cdn.brandfetch.io/id9D7bBcmF/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 30, name: "Berxi", logo: "https://cdn.brandfetch.io/idghEuThsD/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 31, name: "Blitz", logo: "https://cdn.brandfetch.io/idlQmU9OaU/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 32, name: "BTIS", logo: "https://cdn.brandfetch.io/idWLdJ_YO0/w/400/h/158/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 33, name: "Chubb Commercial", logo: "https://cdn.brandfetch.io/idxkL_yOuk/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 34, name: "CNA", logo: "https://cdn.brandfetch.io/id7p0HWFH4/w/400/h/126/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 35, name: "Covercube", logo: "https://cdn.brandfetch.io/idLAhZGVkN/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 36, name: "Covertree", logo: "https://cdn.brandfetch.io/idgSU5Wvx6/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 37, name: "Deductible Defender", logo: "https://cdn.brandfetch.io/idQy0qYjnS/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 38, name: "Delos", logo: "https://cdn.brandfetch.io/idmBYYTNzl/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 39, name: "Diesel", logo: "https://cdn.brandfetch.io/idL5q7O-QT/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 40, name: "Elephant", logo: "https://cdn.brandfetch.io/idNJV6iXrw/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 41, name: "ePremium", logo: "https://cdn.brandfetch.io/idL2DDxkK-/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 42, name: "Ethos", logo: "https://cdn.brandfetch.io/idP0hqQo1T/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 43, name: "First Insurance", logo: "https://cdn.brandfetch.io/idGe1njm7T/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 44, name: "Forge", logo: "https://cdn.brandfetch.io/idjO2LFG82/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 45, name: "Foxquilt", logo: "https://cdn.brandfetch.io/idQTlh-nRu/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 46, name: "GeoVera", logo: "https://cdn.brandfetch.io/id8OxgNQXJ/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 47, name: "Great American", logo: "https://cdn.brandfetch.io/idxOl_CQpL/w/400/h/140/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 48, name: "GUARD", logo: "https://cdn.brandfetch.io/idgMtRhBxH/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 49, name: "Hanover", logo: "https://cdn.brandfetch.io/idGaGq0SyE/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 50, name: "HoneyQuote", logo: "https://cdn.brandfetch.io/idNHxlhG1L/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 51, name: "Hugo", logo: "https://cdn.brandfetch.io/idzwfgqLrE/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 52, name: "ICAT", logo: "https://cdn.brandfetch.io/idPdVHGEKt/w/400/h/118/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 53, name: "IDIQ", logo: "https://cdn.brandfetch.io/idFgXJT9GK/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 54, name: "Insur-Fi", logo: "https://cdn.brandfetch.io/idvLR5czN-/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 55, name: "Kanguro", logo: "https://cdn.brandfetch.io/id-NjYa5QL/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 56, name: "Kelly Klee", logo: "https://cdn.brandfetch.io/idTr4rkWfQ/w/400/h/158/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 57, name: "LIO", logo: "https://cdn.brandfetch.io/idS0xS4Ckw/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 58, name: "MGT", logo: "https://cdn.brandfetch.io/idGSn_I1vM/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 59, name: "Monoline", logo: "https://cdn.brandfetch.io/idSQYpNWPk/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 60, name: "MSI", logo: "https://cdn.brandfetch.io/idKz0bLBv-/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 61, name: "Neptune", logo: "https://cdn.brandfetch.io/idi2kxILPb/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 62, name: "Normandy", logo: "https://cdn.brandfetch.io/idTdJ3LNJP/w/400/h/148/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 63, name: "Novella", logo: "https://cdn.brandfetch.io/idW7ZFdJML/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 64, name: "Novo", logo: "https://cdn.brandfetch.io/idW7SdM6El/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 65, name: "NuSureCo", logo: "https://cdn.brandfetch.io/idaWXuPBEo/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 66, name: "Pathpoint", logo: "https://cdn.brandfetch.io/id5hm9vPmW/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 67, name: "Pie", logo: "https://cdn.brandfetch.io/idCU_4pI2F/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 68, name: "Plymouth Rock", logo: "https://cdn.brandfetch.io/idxAqXQ7I-/w/400/h/96/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 69, name: "Pouch Insurance", logo: "https://cdn.brandfetch.io/idPKoUHNFZ/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 70, name: "Propeller", logo: "https://cdn.brandfetch.io/idSWZWvs6R/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 71, name: "Rainbow", logo: "https://cdn.brandfetch.io/idQnRl5Rup/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 72, name: "Rainwalk", logo: "https://cdn.brandfetch.io/id1g_bxMrM/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 73, name: "RLI", logo: "https://cdn.brandfetch.io/idwY_VxChH/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 74, name: "Roamly", logo: "https://cdn.brandfetch.io/idWJbAa8vU/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 75, name: "Semsee Market Access", logo: "https://cdn.brandfetch.io/iddJdmM8hg/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 76, name: "SES Risk Solutions", logo: "https://cdn.brandfetch.io/idhNMDuLhR/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 77, name: "Simplicity", logo: "https://cdn.brandfetch.io/idGWOt1Yw4/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 78, name: "Slice", logo: "https://cdn.brandfetch.io/idSS6Q1NdR/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 79, name: "Sterling MGA", logo: "https://cdn.brandfetch.io/id0nGmh02r/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 80, name: "Tend", logo: "https://cdn.brandfetch.io/id7pn4VQEK/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 81, name: "THREE by Berkshire Hathaway", logo: "https://cdn.brandfetch.io/idREwqMz9V/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 82, name: "TMR General Agency", logo: "https://cdn.brandfetch.io/idzSVqcTiC/w/400/h/154/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 83, name: "weSure", logo: "https://cdn.brandfetch.io/id78_oEbKg/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" }
,
  // Additional carriers from Gabriel's marked list (avoiding duplicates with existing)
  { id: 84, name: "Acacia", logo: "https://cdn.brandfetch.io/idJE3SyPuZ/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 85, name: "Aggressive", logo: "https://cdn.brandfetch.io/idUxpAF7sj/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 86, name: "Amwins", logo: "https://cdn.brandfetch.io/idL1VHddwE/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 87, name: "AmWINS Star", logo: "https://cdn.brandfetch.io/idL1VHddwE/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 88, name: "Connect", logo: "https://cdn.brandfetch.io/idnj7p3Xkq/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 89, name: "Dairyland", logo: "https://cdn.brandfetch.io/idP4mXEk2l/w/400/h/138/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 90, name: "Empower", logo: "https://cdn.brandfetch.io/idW6j6fgPV/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 91, name: "Entegra General", logo: "https://cdn.brandfetch.io/idPmwS6TjY/w/400/h/101/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 92, name: "Excellent Insurance", logo: "https://cdn.brandfetch.io/id9fQw9WlD/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 93, name: "Lamar", logo: "https://cdn.brandfetch.io/idDGMpvMZX/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 94, name: "LoneStar", logo: "https://cdn.brandfetch.io/id6kEHp3O1/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 95, name: "Mendota", logo: "https://cdn.brandfetch.io/idzYBCTGy7/w/400/h/108/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 96, name: "MyClick", logo: "https://cdn.brandfetch.io/idR3ky8GQF/w/400/h/126/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 97, name: "PointRider", logo: "https://cdn.brandfetch.io/idUNHUlzH2/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 98, name: "Progressive-Drive", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Logo_of_the_Progressive_Corporation.svg/320px-Logo_of_the_Progressive_Corporation.svg.png" },
  { id: 99, name: "Quantum", logo: "https://cdn.brandfetch.io/idJbYrTMg7/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 100, name: "Reliant General", logo: "https://cdn.brandfetch.io/idOe0HKxRZ/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 101, name: "Texas Ranger", logo: "https://cdn.brandfetch.io/idI52o2MjE/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 102, name: "Trinity", logo: "https://cdn.brandfetch.io/id82iBH-p2/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" },
  { id: 103, name: "Venture", logo: "https://cdn.brandfetch.io/idRLNHuEgl/w/400/h/100/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" }
];

export const blogPosts = {
  en: [
    {
      id: 1,
      title: "Understanding Auto Insurance Coverage",
      excerpt: "Learn about the different types of auto insurance coverage and what's right for you.",
      category: "Auto Insurance",
      date: "April 23, 2025",
      image: "https://images.unsplash.com/photo-1637763723578-79a4ca9225f7"
    },
    {
      id: 2,
      title: "Home Insurance: What's Covered?",
      excerpt: "Discover what your home insurance policy covers and how to maximize your protection.",
      category: "Home Insurance",
      date: "April 20, 2025",
      image: "https://images.pexels.com/photos/7735630/pexels-photo-7735630.jpeg"
    },
    {
      id: 3,
      title: "Small Business Insurance Guide",
      excerpt: "Essential insurance coverage every small business owner needs to know about.",
      category: "Business Insurance",
      date: "April 15, 2025",
      image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07"
    }
  ],
  es: [
    {
      id: 1,
      title: "Entendiendo la Cobertura de Seguro de Auto",
      excerpt: "Aprenda sobre los diferentes tipos de cobertura de seguro de auto y cuál es adecuada para usted.",
      category: "Seguro de Auto",
      date: "23 de Abril, 2025",
      image: "https://images.unsplash.com/photo-1637763723578-79a4ca9225f7"
    },
    {
      id: 2,
      title: "Seguro de Casa: ¿Qué Está Cubierto?",
      excerpt: "Descubra qué cubre su póliza de seguro de hogar y cómo maximizar su protección.",
      category: "Seguro de Casa",
      date: "20 de Abril, 2025",
      image: "https://images.pexels.com/photos/7735630/pexels-photo-7735630.jpeg"
    },
    {
      id: 3,
      title: "Guía de Seguro para Pequeños Negocios",
      excerpt: "Cobertura de seguro esencial que todo propietario de pequeño negocio necesita saber.",
      category: "Seguro de Negocio",
      date: "15 de Abril, 2025",
      image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07"
    }
  ]
};

export const autoInsurancePage = {
  en: {
    title: "Personal Auto Insurance",
    subtitle: "Get instant quotes and coverage options tailored to your needs",
    description: "Protect your vehicle with comprehensive auto insurance coverage. Our partners offer competitive rates and flexible payment options.",
    howItWorks: {
      title: "How It Works",
      steps: [
        {
          step: 1,
          title: "Enter Your Information",
          description: "Fill in your vehicle and driver details in the form below"
        },
        {
          step: 2,
          title: "Review Options",
          description: "Compare quotes and coverage options from our trusted partners"
        },
        {
          step: 3,
          title: "Get Covered",
          description: "Choose the best plan and get covered instantly"
        }
      ]
    },
    benefits: [
      "Competitive rates from top carriers",
      "Flexible payment plans available",
      "24/7 customer support",
      "Easy claims process",
      "Multi-vehicle discounts"
    ],
    widgetError: "Unable to load quote form. Please try refreshing the page or contact us directly at",
    needHelp: "Need help? Call us at"
  },
  es: {
    title: "Seguro de Auto Personal",
    subtitle: "Obtenga cotizaciones instantáneas y opciones de cobertura adaptadas a sus necesidades",
    description: "Proteja su vehículo con cobertura integral de seguro de auto. Nuestros socios ofrecen tarifas competitivas y opciones de pago flexibles.",
    howItWorks: {
      title: "Cómo Funciona",
      steps: [
        {
          step: 1,
          title: "Ingrese Su Información",
          description: "Complete los detalles de su vehículo y conductor en el formulario a continuación"
        },
        {
          step: 2,
          title: "Revise las Opciones",
          description: "Compare cotizaciones y opciones de cobertura de nuestros socios de confianza"
        },
        {
          step: 3,
          title: "Obtenga Cobertura",
          description: "Elija el mejor plan y obtenga cobertura al instante"
        }
      ]
    },
    benefits: [
      "Tarifas competitivas de las mejores aseguradoras",
      "Planes de pago flexibles disponibles",
      "Atención al cliente 24/7",
      "Proceso de reclamos fácil",
      "Descuentos por múltiples vehículos"
    ],
    widgetError: "No se puede cargar el formulario de cotización. Por favor intente actualizar la página o contáctenos directamente al",
    needHelp: "¿Necesita ayuda? Llámenos al"
  }
};


export const businessInsurancePage = {
  en: {
    title: "Get a Business Insurance Quote",
    subtitle: "Protect your business with comprehensive commercial insurance coverage",
    description: "From general liability to professional liability, workers' compensation to business property insurance – get instant quotes tailored to your industry and business needs.",
    howItWorks: {
      title: "How It Works",
      steps: [
        {
          step: 1,
          title: "Tell Us About Your Business",
          description: "Share your industry, business type, and coverage needs"
        },
        {
          step: 2,
          title: "Review Coverage Options",
          description: "Compare quotes from top commercial insurance carriers"
        },
        {
          step: 3,
          title: "Get Covered Instantly",
          description: "Purchase your policy and get your certificate of insurance"
        }
      ]
    },
    benefits: [
      "General Liability Insurance",
      "Professional Liability (E&O)",
      "Workers' Compensation",
      "Business Property Insurance",
      "Commercial Auto Insurance",
      "Cyber Liability Coverage"
    ],
    widgetNote: "The quote form below is provided by Thimble, our trusted partner for business insurance. You can allow location access for faster quotes, or enter your information manually.",
    alternativeLink: "If the form doesn't load, click here to get your quote directly",
    needHelp: "Need help? Call us at"
  },
  es: {
    title: "Cotiza tu seguro de negocio",
    subtitle: "Proteja su negocio con cobertura integral de seguro comercial",
    description: "Desde responsabilidad general hasta responsabilidad profesional, compensación laboral hasta seguro de propiedad comercial: obtenga cotizaciones instantáneas adaptadas a su industria y necesidades comerciales.",
    howItWorks: {
      title: "Cómo Funciona",
      steps: [
        {
          step: 1,
          title: "Cuéntenos Sobre Su Negocio",
          description: "Comparta su industria, tipo de negocio y necesidades de cobertura"
        },
        {
          step: 2,
          title: "Revise Opciones de Cobertura",
          description: "Compare cotizaciones de las principales aseguradoras comerciales"
        },
        {
          step: 3,
          title: "Obtenga Cobertura al Instante",
          description: "Compre su póliza y obtenga su certificado de seguro"
        }
      ]
    },
    benefits: [
      "Seguro de Responsabilidad General",
      "Responsabilidad Profesional (E&O)",
      "Compensación de Trabajadores",
      "Seguro de Propiedad Comercial",
      "Seguro de Auto Comercial",
      "Cobertura de Responsabilidad Cibernética"
    ],
    widgetNote: "El formulario de cotización a continuación es proporcionado por Thimble, nuestro socio de confianza para seguros comerciales. Puede permitir el acceso a la ubicación para cotizaciones más rápidas, o ingresar su información manualmente.",
    alternativeLink: "Si el formulario no carga, haga clic aquí para obtener su cotización directamente",
    needHelp: "¿Necesita ayuda? Llámenos al"
  }
};



export const homeInsurancePage = {
  en: {
    title: "Home Insurance",
    subtitle: "Protect your home, condo, or rental property with comprehensive coverage",
    description: "Whether you own a house, condo, or rent your home, we have coverage options tailored to your needs.",
    importantCoverageNotes: {
      title: "Important Coverage Information",
      dwelling: {
        title: "Dwelling Coverage",
        description: "Standard homeowners insurance typically covers your dwelling (the physical structure of your home) against covered perils such as fire, lightning, windstorms, and hail—subject to policy terms, conditions, and exclusions. Coverage availability and specific perils depend on your policy and location."
      },
      flood: {
        title: "Flood Insurance",
        description: "Flood damage is generally NOT covered by standard homeowners insurance policies. Separate flood insurance is required for flood protection. Flood insurance is typically available through the National Flood Insurance Program (NFIP) or private insurers—subject to eligibility, terms, and conditions."
      },
      windHail: {
        title: "Wind & Hail Coverage",
        description: "Wind and hail coverage may be included in your standard policy or require separate coverage or endorsements, depending on your location and insurer. In high-risk areas (such as coastal regions), wind/hail coverage may be subject to separate deductibles, policy limits, or exclusions. Review your specific policy terms to understand what is covered."
      },
      note: "Coverage details, limits, deductibles, and exclusions vary by policy, insurer, and location. Contact us to review your specific needs and policy options."
    },
    coverageTypes: {
      title: "Coverage Options",
      options: [
        { type: "Homeowners", desc: "Full coverage for your house and personal property" },
        { type: "Condo Insurance", desc: "Protection for your condo unit and belongings" },
        { type: "Renters Insurance", desc: "Coverage for your personal property and liability" }
      ]
    },
    coverageExamples: [
      "Dwelling protection (subject to policy terms)",
      "Personal property coverage (subject to policy terms)",
      "Liability protection (subject to policy terms)",
      "Additional living expenses (subject to policy terms)",
      "Medical payments to others (subject to policy terms)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Property address and type (house, condo, or rental)",
        "Year built and square footage",
        "Estimated property value or replacement cost",
        "Details about security features (alarm, gates, etc.)",
        "Claims history (if any)"
      ]
    },
    faq: {
      title: "Homeowners Insurance FAQs",
      subtitle: "Learn more about home insurance coverage and common questions",
      items: [
        {
          question: "Does my homeowners policy cover water damage?",
          answer: "Homeowners insurance typically covers sudden and accidental water damage, such as a burst pipe or water heater failure. However, damage from flooding, sewer backup, or gradual leaks (due to lack of maintenance) is usually NOT covered. Flood insurance and optional endorsements may be needed for additional protection. Always review your specific policy terms."
        },
        {
          question: "What are optional endorsements or riders?",
          answer: "Optional endorsements (also called riders) are add-ons to your policy that provide extra coverage beyond standard limits. Common examples include: water backup coverage, equipment breakdown, personal property replacement cost, jewelry or valuable items coverage, and home business property. Check with your agent to see which endorsements fit your needs."
        },
        {
          question: "How does my deductible work?",
          answer: "A deductible is the amount you pay out-of-pocket before your insurance coverage kicks in. For example, if your claim is $10,000 and your deductible is $1,000, you pay $1,000 and the insurer covers the remaining $9,000 (subject to policy limits and terms). Higher deductibles typically result in lower premiums."
        },
        {
          question: "Does homeowners insurance cover foundation issues?",
          answer: "Foundation damage is generally NOT covered by standard homeowners policies unless it results from a covered peril (like fire or certain types of water damage). Damage from settling, soil movement, or normal wear and tear is typically excluded. Review your policy or ask your agent for specific coverage details."
        },
        {
          question: "What is roof replacement cost coverage?",
          answer: "Roof coverage can vary by policy. Some policies provide \"replacement cost\" coverage, which pays to replace your roof with similar materials (subject to policy limits), while others provide \"actual cash value,\" which factors in depreciation. Older roofs may have limited coverage or higher deductibles. Check your policy for specific roof coverage terms."
        },
        {
          question: "Can I get coverage for sewer or drain backup?",
          answer: "Sewer or drain backup is typically NOT covered by standard homeowners policies. However, many insurers offer an optional endorsement or rider for water backup coverage. This endorsement may cover damage from sewer, drain, or sump pump backup. Ask your agent about adding this protection to your policy."
        }
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro de hogar/condo/renta. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  },
  es: {
    title: "Seguro de Hogar",
    subtitle: "Proteja su casa, condominio o propiedad de alquiler con cobertura integral",
    description: "Ya sea que sea dueño de una casa, condominio o alquile su hogar, tenemos opciones de cobertura adaptadas a sus necesidades.",
    importantCoverageNotes: {
      title: "Información Importante sobre Cobertura",
      dwelling: {
        title: "Cobertura de Vivienda",
        description: "El seguro de propietarios estándar típicamente cubre su vivienda (la estructura física de su hogar) contra peligros cubiertos como incendio, relámpagos, tormentas de viento y granizo—sujeto a términos, condiciones y exclusiones de la póliza. La disponibilidad de cobertura y los peligros específicos dependen de su póliza y ubicación."
      },
      flood: {
        title: "Seguro contra Inundaciones",
        description: "El daño por inundación generalmente NO está cubierto por las pólizas de seguro de propietarios estándar. Se requiere un seguro contra inundaciones separado para protección contra inundaciones. El seguro contra inundaciones típicamente está disponible a través del Programa Nacional de Seguro contra Inundaciones (NFIP) o aseguradoras privadas—sujeto a elegibilidad, términos y condiciones."
      },
      windHail: {
        title: "Cobertura de Viento y Granizo",
        description: "La cobertura de viento y granizo puede estar incluida en su póliza estándar o requerir cobertura o endosos separados, dependiendo de su ubicación y aseguradora. En áreas de alto riesgo (como regiones costeras), la cobertura de viento/granizo puede estar sujeta a deducibles separados, límites de póliza o exclusiones. Revise los términos específicos de su póliza para entender qué está cubierto."
      },
      note: "Los detalles de cobertura, límites, deducibles y exclusiones varían según la póliza, aseguradora y ubicación. Contáctenos para revisar sus necesidades específicas y opciones de póliza."
    },
    coverageTypes: {
      title: "Opciones de Cobertura",
      options: [
        { type: "Propietarios", desc: "Cobertura completa para su casa y propiedad personal" },
        { type: "Seguro de Condominio", desc: "Protección para su unidad de condo y pertenencias" },
        { type: "Seguro para Inquilinos", desc: "Cobertura para su propiedad personal y responsabilidad" }
      ]
    },
    coverageExamples: [
      "Protección de vivienda (sujeto a términos de póliza)",
      "Cobertura de propiedad personal (sujeto a términos de póliza)",
      "Protección de responsabilidad (sujeto a términos de póliza)",
      "Gastos de vida adicionales (sujeto a términos de póliza)",
      "Pagos médicos a terceros (sujeto a términos de póliza)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Dirección y tipo de propiedad (casa, condo o alquiler)",
        "Año de construcción y pies cuadrados",
        "Valor estimado de la propiedad o costo de reemplazo",
        "Detalles sobre características de seguridad (alarma, rejas, etc.)",
        "Historial de reclamos (si aplica)"
      ]
    },
    faq: {
      title: "Preguntas Frecuentes sobre Seguro de Hogar",
      subtitle: "Aprenda más sobre cobertura de seguro de hogar y preguntas comunes",
      items: [
        {
          question: "¿Mi póliza de propietarios cubre daños por agua?",
          answer: "El seguro de propietarios típicamente cubre daños por agua repentinos y accidentales, como una tubería rota o falla del calentador de agua. Sin embargo, el daño por inundación, respaldo de alcantarillado o fugas graduales (debido a falta de mantenimiento) generalmente NO está cubierto. Puede necesitarse seguro contra inundaciones y endosos opcionales para protección adicional. Siempre revise los términos específicos de su póliza."
        },
        {
          question: "¿Qué son los endosos o cláusulas adicionales opcionales?",
          answer: "Los endosos opcionales (también llamados cláusulas adicionales) son complementos a su póliza que proporcionan cobertura extra más allá de los límites estándar. Ejemplos comunes incluyen: cobertura de respaldo de agua, avería de equipos, costo de reemplazo de propiedad personal, cobertura de joyas o artículos valiosos, y propiedad de negocio en casa. Consulte con su agente para ver qué endosos se ajustan a sus necesidades."
        },
        {
          question: "¿Cómo funciona mi deducible?",
          answer: "Un deducible es la cantidad que usted paga de su bolsillo antes de que su cobertura de seguro entre en vigor. Por ejemplo, si su reclamo es de $10,000 y su deducible es de $1,000, usted paga $1,000 y la aseguradora cubre los $9,000 restantes (sujeto a límites y términos de la póliza). Deducibles más altos típicamente resultan en primas más bajas."
        },
        {
          question: "¿El seguro de propietarios cubre problemas de cimientos?",
          answer: "El daño a los cimientos generalmente NO está cubierto por pólizas estándar de propietarios a menos que resulte de un peligro cubierto (como incendio o ciertos tipos de daño por agua). El daño por asentamiento, movimiento del suelo o desgaste normal típicamente está excluido. Revise su póliza o pregunte a su agente para detalles específicos de cobertura."
        },
        {
          question: "¿Qué es la cobertura de costo de reemplazo de techo?",
          answer: "La cobertura de techo puede variar según la póliza. Algunas pólizas proporcionan cobertura de \"costo de reemplazo\", que paga para reemplazar su techo con materiales similares (sujeto a límites de póliza), mientras que otras proporcionan \"valor real en efectivo\", que considera la depreciación. Los techos más antiguos pueden tener cobertura limitada o deducibles más altos. Consulte su póliza para términos específicos de cobertura de techo."
        },
        {
          question: "¿Puedo obtener cobertura para respaldo de alcantarillado o drenaje?",
          answer: "El respaldo de alcantarillado o drenaje típicamente NO está cubierto por pólizas estándar de propietarios. Sin embargo, muchas aseguradoras ofrecen un endoso opcional o cláusula adicional para cobertura de respaldo de agua. Este endoso puede cubrir daños por respaldo de alcantarillado, drenaje o bomba de sumidero. Pregunte a su agente sobre agregar esta protección a su póliza."
        }
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro de hogar/condo/renta. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  }
};

export const lifeInsurancePage = {
  en: {
    title: "Life Insurance",
    subtitle: "Protect your loved ones and secure their financial future",
    description: "Life insurance provides financial protection for your family in the event of your passing, helping cover expenses and maintain their quality of life.",
    back9Link: "https://app.back9ins.com/apply/palerminsurance",
    lifeLinkUrl: "https://lifelink.simplicitygroup.com/agent/palerm-15885?product=mpt",
    educationalSection: {
      title: "Protect the future of those you love",
      description: "A death benefit can help your family replace lost income, cover mortgage and debts, pay final expenses, support your children's education, and maintain financial continuity (subject to policy terms).",
      whyImportant: {
        title: "Why Life Insurance Matters",
        cards: [
          {
            title: "Family",
            icon: "Users",
            description: "Help replace your income to support your loved ones' daily needs and future goals"
          },
          {
            title: "Home & Obligations",
            icon: "Home",
            description: "Cover mortgage payments, debts, and other financial obligations"
          },
          {
            title: "Education",
            icon: "GraduationCap",
            description: "Secure funding for your children's education and future opportunities"
          },
          {
            title: "Peace of Mind",
            icon: "Heart",
            description: "Provide financial security and stability for your family when they need it most"
          }
        ]
      },
      types: {
        title: "Types of Life Insurance",
        term: {
          name: "Term Life Insurance",
          description: "Provides coverage for a specific period (e.g., 10, 20, or 30 years). Generally offers more affordable premiums."
        },
        permanent: {
          name: "Permanent Life Insurance",
          description: "Offers lifelong coverage and may include a cash value component. Options vary by policy type."
        },
        note: "The right choice depends on your individual needs and circumstances. We can help you evaluate both options."
      },
      needsAssessment: {
        title: "Evaluate Your Life Insurance Needs",
        description: "Consider these factors when determining coverage:",
        factors: [
          "Number of dependents relying on your income",
          "Total annual income to replace",
          "Outstanding debts and obligations (mortgage, loans)",
          "Existing life insurance coverage (if any)",
          "Your budget for premiums"
        ]
      },
      faq: [
        {
          question: "How much life insurance do I need?",
          answer: "The amount depends on your individual circumstances, including income, debts, dependents, and financial goals. We can help you assess your needs."
        },
        {
          question: "What about coverage through my employer?",
          answer: "Employer-provided coverage is a benefit, but it's important to review the amount and whether it's portable if you change jobs."
        },
        {
          question: "How do I get started?",
          answer: "Use the quote form below, visit one of our partner portals, or contact us via WhatsApp or phone. We're here to help you find the right coverage."
        }
      ],
      disclaimer: "Important: Submitting a quote or application does not activate coverage. Availability, approval, and rates depend on the insurance carrier, underwriting evaluation, and your state. Coverage begins only when a policy is issued and accepted."
    },
    coverageExamples: [
      "Death benefit for beneficiaries (subject to policy terms)",
      "Term life options (subject to policy terms)",
      "Permanent life options (subject to policy terms)",
      "Accidental death coverage (subject to policy terms)",
      "Living benefits (subject to policy terms)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Age and health information",
        "Desired coverage amount",
        "Beneficiary information",
        "Occupation and income details",
        "Medical history"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro de vida. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  },
  es: {
    title: "Seguro de Vida",
    subtitle: "Proteja a sus seres queridos y asegure su futuro financiero",
    description: "El seguro de vida proporciona protección financiera para su familia en caso de su fallecimiento, ayudando a cubrir gastos y mantener su calidad de vida.",
    back9Link: "https://app.back9ins.com/apply/palerminsurance",
    lifeLinkUrl: "https://lifelink.simplicitygroup.com/agent/palerm-15885?product=mpt",
    educationalSection: {
      title: "Protege el futuro de quienes más amas",
      description: "Un beneficio por fallecimiento puede ayudar a su familia a reemplazar ingresos perdidos, cubrir la hipoteca y deudas, pagar gastos finales, apoyar la educación de sus hijos y mantener la continuidad financiera (sujeto a términos de póliza).",
      whyImportant: {
        title: "Por Qué es Importante el Seguro de Vida",
        cards: [
          {
            title: "Familia",
            icon: "Users",
            description: "Ayude a reemplazar sus ingresos para apoyar las necesidades diarias y metas futuras de sus seres queridos"
          },
          {
            title: "Hogar y Obligaciones",
            icon: "Home",
            description: "Cubrir pagos de hipoteca, deudas y otras obligaciones financieras"
          },
          {
            title: "Educación",
            icon: "GraduationCap",
            description: "Asegurar fondos para la educación de sus hijos y oportunidades futuras"
          },
          {
            title: "Tranquilidad",
            icon: "Heart",
            description: "Proporcionar seguridad y estabilidad financiera para su familia cuando más lo necesitan"
          }
        ]
      },
      types: {
        title: "Tipos de Seguro de Vida",
        term: {
          name: "Seguro de Vida a Término",
          description: "Proporciona cobertura por un período específico (ej., 10, 20 o 30 años). Generalmente ofrece primas más asequibles."
        },
        permanent: {
          name: "Seguro de Vida Permanente",
          description: "Ofrece cobertura de por vida y puede incluir un componente de valor en efectivo. Las opciones varían según el tipo de póliza."
        },
        note: "La elección correcta depende de sus necesidades y circunstancias individuales. Podemos ayudarle a evaluar ambas opciones."
      },
      needsAssessment: {
        title: "Evalúe Sus Necesidades de Seguro de Vida",
        description: "Considere estos factores al determinar la cobertura:",
        factors: [
          "Número de dependientes que dependen de sus ingresos",
          "Ingreso anual total a reemplazar",
          "Deudas y obligaciones pendientes (hipoteca, préstamos)",
          "Cobertura de seguro de vida existente (si la hay)",
          "Su presupuesto para primas"
        ]
      },
      faq: [
        {
          question: "¿Cuánto seguro de vida necesito?",
          answer: "La cantidad depende de sus circunstancias individuales, incluyendo ingresos, deudas, dependientes y metas financieras. Podemos ayudarle a evaluar sus necesidades."
        },
        {
          question: "¿Qué hay de la cobertura a través de mi empleador?",
          answer: "La cobertura proporcionada por el empleador es un beneficio, pero es importante revisar el monto y si es portable si cambia de trabajo."
        },
        {
          question: "¿Cómo empiezo?",
          answer: "Use el formulario de cotización a continuación, visite uno de nuestros portales asociados o contáctenos por WhatsApp o teléfono. Estamos aquí para ayudarle a encontrar la cobertura adecuada."
        }
      ],
      disclaimer: "Importante: Enviar una cotización o solicitud no activa la cobertura. La disponibilidad, aprobación y tarifas dependen de la aseguradora, evaluación de suscripción y su estado. La cobertura comienza solo cuando una póliza es emitida y aceptada."
    },
    coverageExamples: [
      "Beneficio por fallecimiento para beneficiarios (sujeto a términos de póliza)",
      "Opciones de vida temporal (sujeto a términos de póliza)",
      "Opciones de vida permanente (sujeto a términos de póliza)",
      "Cobertura por muerte accidental (sujeto a términos de póliza)",
      "Beneficios en vida (sujeto a términos de póliza)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Edad e información de salud",
        "Monto de cobertura deseado",
        "Información de beneficiarios",
        "Detalles de ocupación e ingresos",
        "Historial médico"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro de vida. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  }
};

export const bondsInsurancePage = {
  en: {
    title: "Surety Bonds",
    subtitle: "Professional bonding solutions for contractors and businesses",
    description: "Surety bonds provide financial guarantee for contract performance, license requirements, and various business obligations.",
    coverageExamples: [
      "Contract bonds (performance, payment, bid)",
      "License and permit bonds",
      "Court bonds (fiduciary, judicial)",
      "Commercial bonds (business service)",
      "Fidelity bonds (employee dishonesty)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Type of bond required",
        "Bond amount needed",
        "Business financial statements",
        "Personal financial information",
        "Business license and experience details"
      ]
    },
    whatsappMessage: "Hola, me interesa información sobre fianzas. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  },
  es: {
    title: "Fianzas",
    subtitle: "Soluciones profesionales de fianzas para contratistas y negocios",
    description: "Las fianzas proporcionan garantía financiera para cumplimiento de contratos, requisitos de licencia y varias obligaciones comerciales.",
    coverageExamples: [
      "Fianzas de contrato (cumplimiento, pago, oferta)",
      "Fianzas de licencia y permiso",
      "Fianzas judiciales (fiduciarias, judiciales)",
      "Fianzas comerciales (servicio empresarial)",
      "Fianzas de fidelidad (deshonestidad de empleados)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Tipo de fianza requerida",
        "Monto de fianza necesario",
        "Estados financieros del negocio",
        "Información financiera personal",
        "Detalles de licencia comercial y experiencia"
      ]
    },
    whatsappMessage: "Hola, me interesa información sobre fianzas. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  }
};

export const commercialAutoPage = {
  en: {
    title: "Commercial Auto Insurance",
    subtitle: "Coverage for vehicles used in your business operations",
    description: "Protect your business vehicles including cars, vans, and light trucks used for commercial purposes.",
    coverageExamples: [
      "Liability coverage (subject to policy terms)",
      "Physical damage coverage (subject to policy terms)",
      "Uninsured motorist coverage (subject to policy terms)",
      "Medical payments (subject to policy terms)",
      "Hired and non-owned auto coverage (subject to policy terms)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Vehicle information (year, make, model, VIN)",
        "Business use details",
        "Driver information and MVRs",
        "Annual mileage estimate",
        "Garaging address"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro de auto comercial. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  },
  es: {
    title: "Seguro de Auto Comercial",
    subtitle: "Cobertura para vehículos utilizados en sus operaciones comerciales",
    description: "Proteja sus vehículos comerciales incluyendo autos, camionetas y camiones ligeros utilizados para fines comerciales.",
    coverageExamples: [
      "Cobertura de responsabilidad (sujeto a términos de póliza)",
      "Cobertura de daños físicos (sujeto a términos de póliza)",
      "Cobertura de motorista sin seguro (sujeto a términos de póliza)",
      "Pagos médicos (sujeto a términos de póliza)",
      "Cobertura de autos alquilados y no propios (sujeto a términos de póliza)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Información del vehículo (año, marca, modelo, VIN)",
        "Detalles de uso comercial",
        "Información de conductores y MVRs",
        "Estimado de millaje anual",
        "Dirección de estacionamiento"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro de auto comercial. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  }
};

export const truckingInsurancePage = {
  en: {
    title: "Trucking Insurance",
    subtitle: "Comprehensive coverage for commercial trucking operations",
    description: "Specialized insurance solutions for trucking companies and owner-operators, covering various aspects of your trucking business.",
    coverageTypes: {
      title: "Coverage Needs to Discuss",
      needs: [
        { type: "Auto Liability (AL)", desc: "Required by law for bodily injury and property damage" },
        { type: "Auto Physical Damage (APD)", desc: "Protects your trucks and trailers from physical damage" },
        { type: "Cargo Insurance", desc: "Covers goods being transported" },
        { type: "Fleet Coverage", desc: "For multiple vehicles in your operation" }
      ]
    },
    coverageExamples: [
      "Primary auto liability (subject to policy terms)",
      "Physical damage coverage (subject to policy terms)",
      "Motor truck cargo (subject to policy terms)",
      "General liability (subject to policy terms)",
      "Trailer interchange (subject to policy terms)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "USDOT number (if you have one, or select 'I don't have USDOT')",
        "MC number (if applicable)",
        "Fleet size and vehicle details",
        "Type of cargo hauled",
        "Operating radius and states",
        "Driver information and experience"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro para trucking. Mi nombre es [NOMBRE], teléfono [TELÉFONO]. ",
    usdotNote: "If you don't have a USDOT number yet, select 'I don't have USDOT' to start your quote request."
  },
  es: {
    title: "Seguro para Camiones",
    subtitle: "Cobertura integral para operaciones de transporte comercial",
    description: "Soluciones de seguro especializadas para compañías de transporte y propietarios-operadores, cubriendo diversos aspectos de su negocio de transporte.",
    coverageTypes: {
      title: "Necesidades de Cobertura a Consultar",
      needs: [
        { type: "Responsabilidad Auto (AL)", desc: "Requerido por ley para lesiones corporales y daños a la propiedad" },
        { type: "Daño Físico Auto (APD)", desc: "Protege sus camiones y remolques de daños físicos" },
        { type: "Seguro de Carga", desc: "Cubre bienes en transporte" },
        { type: "Cobertura de Flota", desc: "Para múltiples vehículos en su operación" }
      ]
    },
    coverageExamples: [
      "Responsabilidad auto primaria (sujeto a términos de póliza)",
      "Cobertura de daños físicos (sujeto a términos de póliza)",
      "Carga de camión motorizado (sujeto a términos de póliza)",
      "Responsabilidad general (sujeto a términos de póliza)",
      "Intercambio de remolques (sujeto a términos de póliza)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Número USDOT (si tiene uno, o seleccione 'No tengo USDOT')",
        "Número MC (si aplica)",
        "Tamaño de flota y detalles de vehículos",
        "Tipo de carga transportada",
        "Radio de operación y estados",
        "Información y experiencia de conductores"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar seguro para trucking. Mi nombre es [NOMBRE], teléfono [TELÉFONO]. ",
    usdotNote: "Si no tiene un número USDOT aún, seleccione 'No tengo USDOT' para iniciar su solicitud de cotización."
  }
};

export const travelInsurancePage = {
  en: {
    title: "Travel Insurance",
    subtitle: "Stay protected wherever your journey takes you",
    description: "Travel assistance plans designed for emergencies and unforeseen setbacks during your trips. Coverage is global and intended for individuals aged 6 months to 99 years.",
    referenceCode: "RTRL006",
    externalLink: "https://www.redbridgeassist.com/",
    coverageHighlights: [
      "Emergency medical and dental care (hospitalizations, surgical procedures, lab tests, X-rays, physician visits - subject to policy terms)",
      "Pre-existing medical conditions coverage (US $500 to US $5,000 depending on plan - subject to policy terms)",
      "COVID-19 coverage for medical emergencies (subject to policy terms)",
      "Emergency transportation and medical repatriation (subject to policy terms)",
      "Trip cancellation and interruption reimbursement (subject to policy terms, eligibility, and limits)",
      "Lost or delayed baggage assistance (subject to policy terms)",
      "Document replacement support (passports, visas, tickets - subject to policy terms)",
      "Legal assistance and support during travel (subject to policy terms)",
      "24/7 travel assistance (subject to policy terms)"
    ],
    planTypes: [
      {
        name: "Single Travel Plans",
        description: "Coverage for trips up to 180 days"
      },
      {
        name: "Unlimited Travel Plans",
        description: "365-day duration with per-trip limits of 30 or 60 days"
      }
    ],
    importantNotes: [
      "These are service-based assistance plans, not traditional health insurance",
      "Coverage depends on the specific plan, eligibility, limits, and exclusions",
      "Claims require notification within 72 hours of event onset",
      "Reimbursement requests must be submitted within 60 days of incident",
      "Valid travel documentation (itineraries, passport copies) required upon request",
      "Optional benefits for pets or adventure sports may be available for additional fee"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Travel dates and destinations",
        "Number of travelers and ages",
        "Trip cost (for cancellation coverage)",
        "Pre-existing medical conditions (if any)",
        "Special coverage needs (adventure sports, pets, etc.)"
      ]
    },
    note: "When requesting a quote, please mention reference code: RTRL006"
  },
  es: {
    title: "Seguro de Viaje",
    subtitle: "Manténgase protegido dondequiera que lo lleve su viaje",
    description: "Planes de asistencia de viaje diseñados para emergencias e imprevistos durante sus viajes. La cobertura es global y está destinada a personas de 6 meses a 99 años.",
    referenceCode: "RTRL006",
    externalLink: "https://www.redbridgeassist.com/",
    coverageHighlights: [
      "Atención médica y dental de emergencia (hospitalizaciones, procedimientos quirúrgicos, pruebas de laboratorio, rayos X, visitas médicas - sujeto a términos de póliza)",
      "Cobertura para condiciones médicas preexistentes (US $500 a US $5,000 dependiendo del plan - sujeto a términos de póliza)",
      "Cobertura COVID-19 para emergencias médicas (sujeto a términos de póliza)",
      "Transporte de emergencia y repatriación médica (sujeto a términos de póliza)",
      "Reembolso por cancelación e interrupción de viaje (sujeto a términos de póliza, elegibilidad y límites)",
      "Asistencia por equipaje perdido o retrasado (sujeto a términos de póliza)",
      "Apoyo para reemplazo de documentos (pasaportes, visas, boletos - sujeto a términos de póliza)",
      "Asistencia legal y apoyo durante el viaje (sujeto a términos de póliza)",
      "Asistencia de viaje 24/7 (sujeto a términos de póliza)"
    ],
    planTypes: [
      {
        name: "Planes de Viaje Único",
        description: "Cobertura para viajes de hasta 180 días"
      },
      {
        name: "Planes de Viaje Ilimitado",
        description: "Duración de 365 días con límites por viaje de 30 o 60 días"
      }
    ],
    importantNotes: [
      "Estos son planes de asistencia basados en servicios, no seguros de salud tradicionales",
      "La cobertura depende del plan específico, elegibilidad, límites y exclusiones",
      "Los reclamos requieren notificación dentro de las 72 horas del inicio del evento",
      "Las solicitudes de reembolso deben presentarse dentro de los 60 días del incidente",
      "Se requiere documentación de viaje válida (itinerarios, copias de pasaporte) a solicitud",
      "Beneficios opcionales para mascotas o deportes de aventura pueden estar disponibles por tarifa adicional"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Fechas de viaje y destinos",
        "Número de viajeros y edades",
        "Costo del viaje (para cobertura de cancelación)",
        "Condiciones médicas preexistentes (si aplica)",
        "Necesidades especiales de cobertura (deportes de aventura, mascotas, etc.)"
      ]
    },
    note: "Al solicitar una cotización, por favor mencione el código de referencia: RTRL006"
  }
};

export const petInsurancePage = {
  en: {
    title: "Pet Insurance",
    subtitle: "Comprehensive coverage for your furry family members",
    description: "Pet insurance helps cover unexpected veterinary costs, ensuring your pets get the care they need without financial stress.",
    externalLink: "https://www.fetchpet.com/mypet?a=FC44360-2&utm_source=firstconnect&utm_medium=brokerportal&utm_campaign=firstconnect_email&c=firstconnect&p=firstconnect",
    coverageExamples: [
      "Accident and illness coverage (subject to policy terms)",
      "Hereditary and congenital conditions (subject to policy terms)",
      "Emergency care (subject to policy terms)",
      "Specialized treatments (subject to policy terms)",
      "Prescription medications (subject to policy terms)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Pet's age, breed, and weight",
        "Medical history and vaccinations",
        "Pre-existing conditions (if any)",
        "Desired coverage level",
        "Deductible preference"
      ]
    }
  },
  es: {
    title: "Seguro para Mascotas",
    subtitle: "Cobertura integral para los miembros peludos de su familia",
    description: "El seguro para mascotas ayuda a cubrir costos veterinarios inesperados, asegurando que sus mascotas reciban la atención que necesitan sin estrés financiero.",
    externalLink: "https://www.fetchpet.com/mypet?a=FC44360-2&utm_source=firstconnect&utm_medium=brokerportal&utm_campaign=firstconnect_email&c=firstconnect&p=firstconnect",
    coverageExamples: [
      "Cobertura de accidentes y enfermedades (sujeto a términos de póliza)",
      "Condiciones hereditarias y congénitas (sujeto a términos de póliza)",
      "Atención de emergencia (sujeto a términos de póliza)",
      "Tratamientos especializados (sujeto a términos de póliza)",
      "Medicamentos recetados (sujeto a términos de póliza)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Edad, raza y peso de la mascota",
        "Historial médico y vacunas",
        "Condiciones preexistentes (si aplica)",
        "Nivel de cobertura deseado",
        "Preferencia de deducible"
      ]
    }
  }
};

export const warrantyInsurancePage = {
  en: {
    title: "Auto Warranty",
    subtitle: "Extended protection for your vehicle beyond manufacturer coverage",
    description: "Auto warranty provides coverage for mechanical breakdowns and repairs after your manufacturer's warranty expires, protecting you from unexpected repair costs.",
    coverageExamples: [
      "Engine and transmission coverage (subject to policy terms)",
      "Electrical system repairs (subject to policy terms)",
      "Air conditioning and heating (subject to policy terms)",
      "Suspension and steering (subject to policy terms)",
      "Roadside assistance (subject to policy terms)"
    ],
    whatToPrepare: {
      title: "What Information to Prepare",
      items: [
        "Vehicle year, make, and model",
        "Current mileage",
        "VIN number",
        "Manufacturer warranty expiration date",
        "Desired coverage level and term"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar garantía extendida para auto. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  },
  es: {
    title: "Garantía de Auto",
    subtitle: "Protección extendida para su vehículo más allá de la cobertura del fabricante",
    description: "La garantía de auto proporciona cobertura para averías mecánicas y reparaciones después de que expira la garantía del fabricante, protegiéndole de costos inesperados de reparación.",
    coverageExamples: [
      "Cobertura de motor y transmisión (sujeto a términos de póliza)",
      "Reparaciones del sistema eléctrico (sujeto a términos de póliza)",
      "Aire acondicionado y calefacción (sujeto a términos de póliza)",
      "Suspensión y dirección (sujeto a términos de póliza)",
      "Asistencia en carretera (sujeto a términos de póliza)"
    ],
    whatToPrepare: {
      title: "Qué Información Preparar",
      items: [
        "Año, marca y modelo del vehículo",
        "Millaje actual",
        "Número VIN",
        "Fecha de expiración de garantía del fabricante",
        "Nivel de cobertura y plazo deseado"
      ]
    },
    whatsappMessage: "Hola, me interesa cotizar garantía extendida para auto. Mi nombre es [NOMBRE] y mi teléfono es [TELÉFONO]."
  }
};
